module.exports = __webpack_public_path__ + "static/media/star.6e1c8ce3.svg";